export default __webpack_public_path__ + "static/media/SndLowerOStop.fce74038.mp3";